/** How a shortcut binding reads, and why a recorded one is refused. Key names stay as the keyboard shows them (same wording as the native menus). */
export default {
  keyLeft: "Left {key}",
  keyRight: "Right {key}",
  holdDoubleTap: "Hold {held} · Double-tap {keys}",
  doubleTap: "Double-tap {keys}",
  holdDrag: "Hold {keys} and drag",
  click: "{keys} + click",
  holdFor: {
    one: "Hold {keys} for {seconds} second",
    other: "Hold {keys} for {seconds} seconds",
  },
  capHold: "Hold {key}",
  capDrag: "drag",
  capClick: "click",
  savedUnreadable: "Could not read saved shortcuts.",
  unsupported: "Choose a supported keyboard shortcut.",
  gestureNotAllowed: "This gesture can’t be used for this action.",
  oneSidePerModifier: "Choose only one side of each modifier.",
  alreadyUsedBy: "Already used by {action}.",
} as const;
